/* eslint-disable */
/* eslint-disable eslint-comments/no-unused-disable */
/* 
* The file is automatically generated by Serenity UI.
* 
* ⚠️ WARNING: Any manual changes may be overwritten during the next upgrade
* 
* Found an issue? Submit a task to the ClickUp board:
* https://app.clickup.com/1255586/v/l/6-901510012553-1?pr=90154030902
*/
import * as stylex from '@stylexjs/stylex';
import { type ForwardedRef, type ReactElement, createContext, forwardRef } from 'react';
import { type ContextValue, Tree as TreeCore, type TreeProps as TreeCoreProps, useContextProps } from 'react-aria-components';

interface TreeProps<T> extends Omit<TreeCoreProps<T>, 'style' | 'className'> {
  style?: stylex.StyleXStyles;
}

const TreeContext = createContext<ContextValue<TreeProps<object>, HTMLDivElement>>({});

const Tree = forwardRef((props: TreeProps<object>, ref: ForwardedRef<HTMLDivElement>) => {
  [props, ref] = useContextProps(props, ref, TreeContext);

  const { style, children, ...coreProps } = props;

  return (
    <TreeCore ref={ref} {...stylex.props(styles.base, style)} {...coreProps}>
      {children}
    </TreeCore>
  );
}) as <T>(p: TreeProps<T> & { ref?: ForwardedRef<HTMLDivElement> }) => ReactElement;

const styles = stylex.create({
  base: {
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
  },
});

export { Tree, TreeContext, type TreeProps };
